import React from "react";
import "./index.css";
import WarningIcon from "../../../../Theming/icons/WarningIcon";
const GlobalErrorComponent = props => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, (props.title || props.message) && /*#__PURE__*/React.createElement("div", {
    role: "alert",
    className: `global-errors ${props.className ? props.className : ""}`
  }, /*#__PURE__*/React.createElement(WarningIcon, {
    className: "global-errors__icon"
  }), /*#__PURE__*/React.createElement("div", null, props.title && /*#__PURE__*/React.createElement("h6", {
    className: "global-errors__title"
  }, props.title), props.message && /*#__PURE__*/React.createElement("p", {
    className: "global-errors__text"
  }, props.message))));
};
export default GlobalErrorComponent;